import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';

import { SubAbasEmpenhos, SubAbasEmpenhosNovo } from './subabasEmpenhos';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { getNotaVersao } from '../../../../services/gestaoSisAF/notaVersaoSisafService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { formataNomeMeioSiglas } from '../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
} from '../../../../utils/swal';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;

export default function EmpenhosFicha() {
  //PERMISSOES-MODULOS
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();
  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find((modulo) => modulo.label === 'Empenhos')?.value ||
      '0',
  );

  // Verificar permissões para ações
  //const canDownload = isActionAllowed(MODULO, 'read', papelUsuarioOptions);
  // const canInsert = isActionAllowed(MODULO, 'create', papelUsuarioOptions);

  const canDelete = isActionAllowed(MODULO, 'delete', papelUsuarioOptions);
  const canSave = isActionAllowed(MODULO, 'update', papelUsuarioOptions);
  //PERMISSOES
  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  //Dados do componente
  let logs = {};
  let subAbas = [];

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formNotaVersao, setFormNotaVersao] = useState({
    usuarioId: userID,
    statusVersao: '',
    dataVersao: '',
    tagVersao: '',
    descricao: '',
    link: '',
    observacoes: '',
  });

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getNotaVersao(id);
      setLogData(registroData);
      setFormNotaVersao({
        usuarioId: userID,
        statusVersao: registroData.statusVersao,
        dataVersao: registroData.dataVersao,
        tagVersao: registroData.tagVersao,
        descricao: registroData.descricao,
        link: registroData.link,
        observacoes: registroData.observacoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const amarelo = '#faffb4dd';

    console.log('Status:', formNotaVersao.statusVersao);

    const status = String(formNotaVersao.statusVersao);
    console.log('Status atual:', status); // Adicionado para depurar

    const newStatusStyle = {
      backgroundColor:
        status === '1'
          ? amarelo
          : status === '2'
            ? verde
            : status === '3'
              ? vermelho
              : 'white',
    };

    setStatusStyle(newStatusStyle);
  }, [formNotaVersao.statusVersao]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isDateReadOnly, setIsDateReadOnly] = useState(true);
  useEffect(() => {
    if (
      formNotaVersao.statusVersao == '1' ||
      formNotaVersao.statusVersao == '3'
    ) {
      setIsDateReadOnly(true);
      setFormNotaVersao((prev) => ({
        ...prev,
        dataVersao: '',
      }));
    } else {
      setIsDateReadOnly(false);
    }
  }, [formNotaVersao.statusVersao]);

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasEmpenhos(fichaID);
  } else {
    subAbas = SubAbasEmpenhosNovo;
  }

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;
    console.log('Campo alterado:', name, 'Novo valor:', value); // Verificar qual campo está sendo alterado e o valor
    setFormNotaVersao((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.statusVersao) {
      errors.push('<b>Status da versão</b> é obrigatório.');
    }

    if (!form.tagVersao) {
      errors.push('Nome da <b>tag da versão</b> é obrigatório.');
    }

    if (!form.descricao) {
      errors.push('<b>Descrição</b> é obrigatório.');
    }

    if (form.statusVersao == '2' && form.dataVersao == '') {
      errors.push('<b>Data da versão</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalErro(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formNotaVersao);
      if (!isFormValid) return;

      console.log(formNotaVersao);

      const formToSend = {
        ...formNotaVersao,
        statusVersao: Number(formNotaVersao.statusVersao),
        dataVersao: formNotaVersao.dataVersao
          ? formNotaVersao.dataVersao
          : null,
      };

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(
        `/api/notaversaosisaf/`,
        formToSend,
      );

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/maisopcoes/notas/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formNotaVersao);
      if (!isFormValid) return;

      const formToSend = {
        ...formNotaVersao,
        statusVersao: Number(formNotaVersao.statusVersao),
        dataVersao: formNotaVersao.dataVersao
          ? formNotaVersao.dataVersao
          : null,
      };

      const response = await httpClient.patch(
        `/api/notaversaosisaf/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/notaversaosisaf/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/maisopcoes/notas');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/proaq/empenhos"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} />

          <BoxConteudo
            boxTitulo="Identificação do Empenho"
            fechado
          ></BoxConteudo>
          <BoxConteudo boxTitulo="Itens Empenhados" fechado></BoxConteudo>

          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formNotaVersao.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            deleteDisabled={!canDelete}
            onClickDelete={handleDelete}
            save
            saveDisabled={!canSave}
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
